export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 2_02.f9beca7c.jpg";